import { useEffect, useRef } from 'react';
import { useLocation, useMatches } from 'react-router-dom';
import { analyticsService } from '@root/app/shared/new-services/analytics.service';
import { authService } from '@root/app/shared/new-services/auth.service';

interface RouteHandle {
    pageTitle?: string;
    routeName?: string;
}

export const usePageAnalytics = (): void => {
    const location = useLocation();
    const matches = useMatches();
    const previousRouteRef = useRef<string | undefined>();

    useEffect(() => {
        const match = matches[matches.length - 1];
        const handle = match?.handle as RouteHandle | undefined;
        const routeName = handle?.routeName ?? match?.id ?? location.pathname;

        analyticsService.trackPageView({
            routeName: String(routeName),
            path: location.pathname,
            pageTitle: handle?.pageTitle,
            previousRouteName: previousRouteRef.current,
            isAuthenticated: authService.isLoggedIn(),
            routeParams: match?.params as Record<string, string>
        });

        previousRouteRef.current = String(routeName);
    }, [location.pathname, matches]);
};
